import { GetServerSideProps } from 'next';

import EmotionDetectorContextProvider from '@/components/emotion-detector/EmotionDetectorContextProvider';
import EmotionDetectorScreens from '@/components/emotion-detector/EmotionDetectorScreens';
import Layout from '@/components/layout/LayoutWrapper';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const EmotionDetector = () => {
	return (
		<Layout pageName="emotion-detector" title="Emotion Detector - Calm">
			<EmotionDetectorContextProvider>
				<EmotionDetectorScreens />
			</EmotionDetectorContextProvider>
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			initialState,
		},
	};
};

export default EmotionDetector;
